module.exports = __webpack_public_path__ + "static/media/selfie_helper.83978dd6.svg";